
angular.module('v3sWbtPlayerApp').directive('v3sText', ["v3sIconService", "$compile", "$window", "v3sI18nService", "v3sResponsiveScaleService","$timeout", function (v3sIconService, $compile, $window, v3sI18nService, v3sResponsiveScaleService,$timeout) {
    return {
        restrict: 'E',
        require: '^v3sDocument',
        controller : ['$scope', '$element', TextController],
        scope: {
            id: '@',
            v3sType: '@',
            v3sName: '@',
            v3sTitle: '@',
            v3sShowtitle: '@',
            v3sVisibility: '@',
            v3sPulldown: '@'
        },
        transclude: true,
        templateUrl: "app/js/page/elements/text.tpl.html",
        link: function (scope, element, attributes, docCtrl, transclude) {
            var align = "left";
            var button = null;
            var oldButton = null;

            var timeoutPromise;
            if (!!scope.id) {
                docCtrl.addElement(element);
            }

            scope.v3sHeader = "";
            if (scope.v3sShowtitle !== 'false') {
                scope.v3sHeader = scope.v3sTitle || scope.v3sName || "content.textboxes." + scope.v3sType;
            }

            if (scope.v3sPulldown && scope.v3sPulldown != "smart") {
                var pulldownToggle = angular.element(element[0].querySelector("header > .v3s-icon-caret-down"));

                pulldownToggle.on("click", function (evt) {
                    element.toggleClass("v3s-pulldown-closed");
                    if (attributes.v3sResponsiveWidth) {
                        v3sResponsiveScaleService.doResizeElement(element);
                        if (timeoutPromise) $timeout.cancel(timeoutPromise);
                        timeoutPromise = $timeout(function () {
                            v3sResponsiveScaleService.doResizeElement(element);
                        }, 800);
                    }
                });
                element.addClass("v3s-pulldown v3s-pulldown-closed");
            }

            scope.textClass = scope.v3sType || "normal";
            element.addClass(scope.textClass);

            /**
             * Alignment aus dem v3s-data element ziehen
             */

            transclude(scope, function (clone, scope) {
                angular.forEach(clone, function (node, index) {
                    var tagName = null;

                    if (!!node.tagName) {
                        tagName = node.tagName.toLowerCase();
                    }

                    if (tagName == "v3s-data") {
                        align = clone.attr('v3s-textalign');
                        element.attr('');

                    } else if (tagName == "v3s-popup-button") { // vor 8 SR 13
                        oldButton = "v3s-popup-button";
                        button = node.outerHTML.replace("-popup-", "-");

                    } else if (tagName == "v3s-reference") { // ab 8 SR 13
                        oldButton = "v3s-reference";
                        button = "<v3s-button>" + node.outerHTML + "</v3s-button>";
                    }
                });
            });

            if (oldButton) {
                oldButton = element[0].querySelector(oldButton);
                oldButton.parentElement.removeChild(oldButton);
            }

            if (button) {
                var newButton = angular.element(button);
                element.append(newButton);
                element.addClass("v3s-text-with-button");
                $compile(newButton)(scope);
                //console.dir(newButton);
            }

            /**
             * entsprechende alignment klasse setzen
             */
            switch (align) {
                case "center":
                    element.addClass('v3s-align-center');
                    break;
                case "right":
                    element.addClass('v3s-align-right');
                    break;
                default:
                    element.addClass('v3s-align-left');
                    break;
            }
            /**
             * Add the right Icon
             */

            var iconEl = angular.element(element[0].querySelector('i:first-child'));
            var iconClass = 'hidden';
            var iconTextBoxes = ['question', 'speaker', 'tip', 'info', 'example', 'paragraph', 'emphasis', 'contact', 'imprint', 'release', 'warning', 'money', 'document', 'link', 'calc', 'speaker', 'law', 'jurisdiction', 'task'];
            //Wenn es eine icontextbox ist muss das icon gesetzt werden
            if (iconTextBoxes.indexOf(scope.textClass) != -1) {
                iconClass = v3sIconService.getIconClass(scope.textClass);
            }

            iconEl.addClass(iconClass);
        }
    }
}]);

function TextController($scope, $element) {
    var vm = this;
    var btn,
        btnOffsets = {},
        elementOffsets,
        actualWidth;

    vm.getActualWidth = function () {
        btn = $element.find("v3s-button")[0];
        elementOffsets = {
            left: $element[0].offsetLeft,
            width: $element[0].offsetWidth
        };

        if (!!btn) {
            btnOffsets.left = btn.offsetLeft;
            btnOffsets.width = btn.offsetWidth;
            if (btnOffsets.left < 0) {// Der Button ist links
                actualWidth = elementOffsets.width + Math.abs(btnOffsets.left);
            } else {
                actualWidth = elementOffsets.width + btnOffsets.left + btnOffsets.width;
            }
        }

        return actualWidth;
    }

    vm.getActualHeight = function () {
        btn = $element.find("v3s-button")[0];

        var btnHeight = btn ? btn.offsetHeight : 0;

        return ($element[0].offsetHeight > btnHeight) ? $element[0].offsetHeight : btnHeight;
    }

    vm.getActualLeft = function () {
        btn = $element.find("v3s-button")[0];
        if (!!btn) {
            if (btn.offsetLeft < 0) {
                return btn.offsetLeft;
            } else {
                return 0;
            }
        }

    }

}